const tooltipSelector = "[data-site-tooltip]";
const activeClass = "site-tooltips-enabled";
const bubbleClass = "site-tooltip__bubble";
const visibleClass = "site-tooltip__bubble--visible";
const delay = 350;
const offset = 8;
const viewportPadding = 12;

let bubble;
let activeTarget;
let showTimer;

const getBubble = () => {
  if (!bubble) {
    bubble = document.createElement("div");
    bubble.className = bubbleClass;
    bubble.setAttribute("role", "tooltip");
    document.body.append(bubble);
  }

  return bubble;
};

const hideTooltip = () => {
  window.clearTimeout(showTimer);
  activeTarget = null;

  if (bubble) {
    bubble.classList.remove(visibleClass);
  }
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const positionBubble = (target, tooltipBubble) => {
  const targetRect = target.getBoundingClientRect();
  const bubbleRect = tooltipBubble.getBoundingClientRect();
  const isCenter = target.classList.contains("site-tooltip--center");
  const isRight = target.classList.contains("site-tooltip--right");
  const topBelow = targetRect.bottom + offset;
  const hasSpaceBelow = topBelow + bubbleRect.height <= window.innerHeight - viewportPadding;
  const top = hasSpaceBelow
    ? topBelow
    : Math.max(viewportPadding, targetRect.top - bubbleRect.height - offset);
  let left = targetRect.left;

  if (isCenter) {
    left = targetRect.left + targetRect.width / 2 - bubbleRect.width / 2;
  }

  if (isRight) {
    left = targetRect.right - bubbleRect.width;
  }

  tooltipBubble.style.left = `${clamp(left, viewportPadding, window.innerWidth - bubbleRect.width - viewportPadding)}px`;
  tooltipBubble.style.top = `${top}px`;
};

const showTooltip = (target) => {
  const text = target.getAttribute("data-site-tooltip");

  if (!text) {
    return;
  }

  const tooltipBubble = getBubble();
  activeTarget = target;
  tooltipBubble.textContent = text;
  tooltipBubble.classList.add(visibleClass);
  positionBubble(target, tooltipBubble);
};

const scheduleTooltip = (target) => {
  window.clearTimeout(showTimer);
  showTimer = window.setTimeout(() => showTooltip(target), delay);
};

document.documentElement.classList.add(activeClass);

document.querySelectorAll(tooltipSelector).forEach((target) => {
  target.addEventListener("pointerenter", () => scheduleTooltip(target));
  target.addEventListener("pointerleave", hideTooltip);
  target.addEventListener("focusin", () => scheduleTooltip(target));
  target.addEventListener("focusout", hideTooltip);
});

window.addEventListener("scroll", hideTooltip, { passive: true });
window.addEventListener("resize", () => {
  if (activeTarget && bubble?.classList.contains(visibleClass)) {
    positionBubble(activeTarget, bubble);
  }
});
